import React from 'react';
import styled from 'styled-components';
import SyncLoader from 'react-spinners/SyncLoader';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const Loader = () => (
  <Overlay>
    <SyncLoader size="30px" color="#8C1D40" />
  </Overlay>
);

export { Loader };
